import { Deserializable } from '../_common/deserializable';

export class SummarySchedule implements Deserializable{
    id: number;
    shortCode: string;
    keyword: string;
    sourceView: string;
    typeView: string;
    country: string;
    fromDay: number;
    toDay: number;
    currentDay: number;
    state: number;
    stateView: string;
    error: string;
    description: string;
    modifiedAt: number;
    createdAt: number;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }

}
